
export type TimezoneOption = {
  key: string;
  value: string;
};

export const buildTimezoneOptions = (): TimezoneOption[] => [
  { key: "(UTC-10:00) Hawaii Time", value: "Pacific/Honolulu" },
  { key: "(UTC-09:00) Alaska Time", value: "America/Anchorage" },
  { key: "(UTC-08:00) Pacific Time", value: "America/Los_Angeles" },
  { key: "(UTC-07:00) Mountain Time", value: "America/Denver" },
  { key: "(UTC-06:00) Central Time", value: "America/Chicago" },
  { key: "(UTC-05:00) Eastern Time", value: "America/New_York" },
  { key: "(UTC-05:00) Bogota", value: "America/Bogota" },
  { key: "(UTC-05:00) Lima", value: "America/Lima" },
  { key: "(UTC-04:00) Atlantic Time", value: "America/Halifax" },
  { key: "(UTC-04:00) Santiago", value: "America/Santiago" },
  { key: "(UTC-03:30) Newfoundland Time", value: "America/St_Johns" },
  { key: "(UTC-03:00) São Paulo", value: "America/Sao_Paulo" },
  { key: "(UTC-03:00) Buenos Aires", value: "America/Argentina/Buenos_Aires" },
  { key: "(UTC-03:00) Montevideo", value: "America/Montevideo" },
  { key: "(UTC+00:00) Coordinated Universal Time", value: "UTC" },
  { key: "(UTC+00:00) London", value: "Europe/London" },
  { key: "(UTC+00:00) Lisbon", value: "Europe/Lisbon" },
  { key: "(UTC+01:00) Paris", value: "Europe/Paris" },
  { key: "(UTC+01:00) Berlin", value: "Europe/Berlin" },
  { key: "(UTC+01:00) Rome", value: "Europe/Rome" },
  { key: "(UTC+01:00) Madrid", value: "Europe/Madrid" },
  { key: "(UTC+01:00) Amsterdam", value: "Europe/Amsterdam" },
  { key: "(UTC+01:00) Brussels", value: "Europe/Brussels" },
  { key: "(UTC+01:00) Zurich", value: "Europe/Zurich" },
  { key: "(UTC+01:00) Vienna", value: "Europe/Vienna" },
  { key: "(UTC+02:00) Athens", value: "Europe/Athens" },
  { key: "(UTC+02:00) Helsinki", value: "Europe/Helsinki" },
  { key: "(UTC+02:00) Cairo", value: "Africa/Cairo" },
  { key: "(UTC+02:00) Johannesburg", value: "Africa/Johannesburg" },
  { key: "(UTC+03:00) Moscow", value: "Europe/Moscow" },
  { key: "(UTC+03:00) Riyadh", value: "Asia/Riyadh" },
  { key: "(UTC+03:00) Nairobi", value: "Africa/Nairobi" },
  { key: "(UTC+03:30) Tehran", value: "Asia/Tehran" },
  { key: "(UTC+04:00) Dubai", value: "Asia/Dubai" },
  { key: "(UTC+04:00) Baku", value: "Asia/Baku" },
  { key: "(UTC+04:30) Kabul", value: "Asia/Kabul" },
  { key: "(UTC+05:00) Karachi", value: "Asia/Karachi" },
  { key: "(UTC+05:00) Tashkent", value: "Asia/Tashkent" },
  { key: "(UTC+05:30) India Standard Time", value: "Asia/Kolkata" },
  { key: "(UTC+05:45) Kathmandu", value: "Asia/Kathmandu" },
  { key: "(UTC+06:00) Dhaka", value: "Asia/Dhaka" },
  { key: "(UTC+06:00) Almaty", value: "Asia/Almaty" },
  { key: "(UTC+06:30) Yangon", value: "Asia/Yangon" },
  { key: "(UTC+07:00) Bangkok", value: "Asia/Bangkok" },
  { key: "(UTC+07:00) Jakarta", value: "Asia/Jakarta" },
  { key: "(UTC+07:00) Ho Chi Minh City", value: "Asia/Ho_Chi_Minh" },
  { key: "(UTC+08:00) Singapore", value: "Asia/Singapore" },
  { key: "(UTC+08:00) Kuala Lumpur", value: "Asia/Kuala_Lumpur" },
  { key: "(UTC+08:00) Hong Kong", value: "Asia/Hong_Kong" },
  { key: "(UTC+08:00) Shanghai", value: "Asia/Shanghai" },
  { key: "(UTC+08:00) Taipei", value: "Asia/Taipei" },
  { key: "(UTC+08:00) Perth", value: "Australia/Perth" },
  { key: "(UTC+09:00) Tokyo", value: "Asia/Tokyo" },
  { key: "(UTC+09:00) Seoul", value: "Asia/Seoul" },
  { key: "(UTC+09:30) Darwin", value: "Australia/Darwin" },
  { key: "(UTC+09:30) Adelaide", value: "Australia/Adelaide" },
  { key: "(UTC+10:00) Sydney", value: "Australia/Sydney" },
  { key: "(UTC+10:00) Melbourne", value: "Australia/Melbourne" },
  { key: "(UTC+10:00) Brisbane", value: "Australia/Brisbane" },
  { key: "(UTC+10:00) Guam", value: "Pacific/Guam" },
  { key: "(UTC+11:00) Solomon Islands", value: "Pacific/Guadalcanal" },
  { key: "(UTC+11:00) New Caledonia", value: "Pacific/Noumea" },
  { key: "(UTC+12:00) Auckland", value: "Pacific/Auckland" },
  { key: "(UTC+12:00) Fiji", value: "Pacific/Fiji" },
  { key: "(UTC+13:00) Tonga", value: "Pacific/Tongatapu" },
  { key: "(UTC+13:00) Samoa", value: "Pacific/Apia" },
  { key: "(UTC+14:00) Kiritimati", value: "Pacific/Kiritimati" },
];